import { render, staticRenderFns } from "./ResVpc.vue?vue&type=template&id=783b870f&scoped=true&"
import script from "./ResVpc.vue?vue&type=script&lang=js&"
export * from "./ResVpc.vue?vue&type=script&lang=js&"
import style0 from "./ResVpc.vue?vue&type=style&index=0&id=783b870f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783b870f",
  null
  
)

export default component.exports